/*
 * @Author: wangbaihe
 * @Date: 2023-04-06 18:42:01
 * @LastEditors: liuxiuting
 * @LastEditTime: 2025-11-17 11:05:07
 * @FilePath: \carrier\packages\common-mediax\src\apis\ImgLibrary\PhotoCropCom.js
 * @Description: BUG #609119 图片加水印接口添加超时时间120s
 */
import { createAPI } from '@common'

export default {
  getFounderAIImageObjectDetectSwitch: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0jnbhfPckfduEfufduTxjudi',
      'get',
      config,
      vconfig
    ), // 图像主体检测开关
  getImageObjectDetect: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0hfuJnbhfPckfduEfufdu',
      'get',
      config,
      vconfig
    ), // 图像主体检测接口
  getE5ImageFile: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhfgjmf', 'get', config, {
      timeout: 120000,
      ...vconfig
    }), // e5获取图片流
  getWatermarks: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl0fejuMjtu', 'get', config, vconfig), //获取水印列表
  deleteWatermark: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl0efmfuf', 'post', config, vconfig), //删除水印
  simpleSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0xbufsnbsl0tjnqmfTbwf', 'post', config, vconfig), //上传图片时，保存上传的图片
  postArticleEditImage: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0qjdGpsxbse0qipup0fejuJnbhf', 'post', config, {
      timeout: 180000,
      ...vconfig
    }), // 图片在线编辑保存借口
  postSourceEditImage: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0qjdGpsxbse0qipup0fejuJnbhf', 'post', config, {
      timeout: 180000,
      ...vconfig
    }), // 图片在线编辑保存借口
  getImageObjectDetectSwitch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpoufou0bj0jnbhfPckfduEfufduTxjudi', 'get', config),
  getImagefaceDetect: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpvoefsBJ0gbdfEfufdu', 'post', config, vconfig), // 人脸检测接口
  getImageCheck: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf0jnbhfDifdl', 'post', config, vconfig), // 人脸图片校验接口

  // 物体检测
  getLandmarkObjectDetect: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpvoefsBJ0pckfduEfufdu', 'post', config, vconfig),
  adjustPicSize: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qjd0bekvtu', 'post', config, {
      timeout: 180000,
      ...vconfig
    })//图片尺寸调整（抽图）
}
